import React, { useContext } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { Box, Button, Card, CardContent, CardHeader, CardTitle, Hero, InfoPanel, StepItem, Typography } from '@otcmarketsgroup/otcm-ui-lib';
import { ProfileContext } from '../context/Profile.context';
import { routes } from '../constants';
import { withRouter } from '../components/WithRouter';
import { ChevronLeft } from 'lucide-react';

const SuccessPage = ({ params: { symbol } }) => {
    const [profileState, dispatchProfile] = useContext(ProfileContext);
    const companyName = profileState?.profile?.companyInfo?.companyName;
    const companyInfoRoute = `${routes.PROFILE_PREFIX}/${symbol}/company-info`;

    if (!profileState.isSubmitted) {
        return <Navigate to={companyInfoRoute} replace />;
    }

    const heroTitle = profileState.successSubmitType === 'update' ? 'Company Update Submitted!' : 'Profile Verification Submitted!';

    const handleBackToProfile = () => {
        dispatchProfile({
            type: 'RESET_SUCCESS',
        });
    };

    return (
        <Box display='flex' flexDirection='column' gap={2}>
            <Hero
                variant='success'
                title={heroTitle}
            />
            <Card>
                <CardContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <Typography variant='h3'>
                            What Happens Next?
                        </Typography>
                        <StepItem
                            label="OTC Markets will review"
                            description={`Please allow OTC Markets 1-2 business days to review and process this form for ${companyName || 'your company'}`}
                            number={1}
                        />
                        <StepItem
                            label="Your profile will be updated"
                            description="Once OTC Markets approves your submission, your profile will be updated on otcmarkets.com"
                            number={2}
                        />
                    </Box>
                </CardContent>
            </Card>
            <InfoPanel title={<>
                If you have any questions, please reach out to <Box component="span" sx={{ color: "var(--otc-green)", ":hover": { textDecoration: "underline" } }}><a href="mailto:issuers@otcmarkets.com">issuers@otcmarkets.com</a></Box> or call 212-896-4420.
            </>} />
            <Box display='flex' justifyContent='flex-end'>
                <Button variant='outlined' startIcon={<ChevronLeft size={14} />} onClick={handleBackToProfile}>
                    Back to Profile
                </Button>
            </Box>
        </Box>
    );
};

export default withRouter(SuccessPage);
